import { Injectable } from '@angular/core';
import { MaintenanceCheck } from './maintenance.model';

@Injectable()
export class MaintenanceCheckService {

  private _maintenanceCheck: MaintenanceCheck;
  private _selectedMaintenanceCheck: number = -1;

  constructor() { }

  get maintenanceCheck() : MaintenanceCheck{
    return this._maintenanceCheck;
  }

  set maintenanceCheck(maintenanceCheck : MaintenanceCheck) {
    this._maintenanceCheck = maintenanceCheck;
  }

  get selectedMaintenanceCheck(): number {
    return this._selectedMaintenanceCheck;
  }

  set selectedMaintenanceCheck(value: number) {
    this._selectedMaintenanceCheck = value;
  }
}
